import { useSelector } from "react-redux";
import { getSiteRoleRights } from "../../helpers/selectors";
import AccessDenied from "../../components/common/AccessDenied";
import OneStreamPage from "./OneStreamPage";

const OneStreamProtectedPage = () => {
  const rights = useSelector(getSiteRoleRights);

  if (!rights) {
    return null;
  }

  const { canUseOneStream } = rights;

  return canUseOneStream ? (
    <OneStreamPage />
  ) : (
    <AccessDenied page="OneStream" />
  );
};

export default OneStreamProtectedPage;
